module.exports = __webpack_public_path__ + "img/emptyCart.9cf9463b.png";